export default __webpack_public_path__ + "static/media/(51).bdd4a85a.jpg";